import { useMemo } from 'react';
import useStateRef from '@web-mail/hooks/useStateRef';
import { HotKeysType } from '@web-common/state/reducer/hotkeysReducer';
import { apiHolder as api } from 'api';
import { useRegistMailHK } from '../ListHotKeys/moduleHotKey';
import { MAIL_HOTKEY_MODULE_TYPE } from '../../common/constant';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
const eventApi = api.api.getEventApi();
const useMailListHotkeys = (props) => {
    const { data, activeId, onActiveInWindow, hkDisabled, onDelete } = props;
    const activeIdRef = useStateRef(activeId);
    const onDeleteProxy = useCreateCallbackForEvent(onDelete);
    const dataRef = useStateRef(data);
    const hkParams = useMemo(() => {
        return {
            handler: {
                [HotKeysType.XUANZHONGYOUJIANXIN]: () => {
                    onActiveInWindow(activeIdRef.current);
                },
                [HotKeysType.BIAOJIYIDU]: {
                    handler: () => {
                        let account = '';
                        dataRef.current.forEach((item) => {
                            if (item.id === activeIdRef.current[0]) {
                                account = item._account || '';
                            }
                        });
                        eventApi.sendSysEvent({
                            eventName: 'mailStatesChanged',
                            eventData: {
                                mark: true,
                                id: activeIdRef.current,
                                type: 'read',
                            },
                            _account: account,
                            eventStrData: 'read',
                        });
                    },
                    level: 10,
                },
                [HotKeysType.BIAOJIWEIDU]: {
                    handler: () => {
                        let account = '';
                        dataRef.current.forEach((item) => {
                            if (item.id === activeIdRef.current[0]) {
                                account = item._account || '';
                            }
                        });
                        eventApi.sendSysEvent({
                            eventName: 'mailStatesChanged',
                            eventData: {
                                mark: false,
                                id: activeIdRef.current,
                                type: 'read',
                            },
                            _account: account,
                            eventStrData: 'unread',
                        });
                    },
                    level: 10,
                },
                [HotKeysType.SHANCHUYOUJIAN]: {
                    handler: () => {
                        onDeleteProxy(activeIdRef.current);
                    },
                    level: 10,
                },
            },
            disabled: hkDisabled,
        };
    }, []);
    useRegistMailHK(MAIL_HOTKEY_MODULE_TYPE.MAIL_LIST_CSTOM, hkParams);
};
export default useMailListHotkeys;
